import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Appointment } from '../interfaces/date-selection.interface';
import { RelatedProfileDTO, UsersAccountDTO } from '../classes/user-account.dto';
import { IDocumentCard } from '../interfaces/document-card.interface';

@Injectable({
  providedIn: 'root',
})
export class AppointmentStepperService {
  users?: UsersAccountDTO;
  user?: UsersAccountDTO | RelatedProfileDTO;
  specialistChosen?: FormGroup;
  requestChosen?: FormGroup;
  dateSelectionChosen?: Appointment[];
  radioAlimentationChosen?: FormGroup;
  appointmentType?: string | null;
  documentsChosen: IDocumentCard[] = [];
  travelFormChosen?: FormGroup;

  /**
   * Sets the list of users
   * @param users - Instance of UsersAccountDTO
   */
  public setUsers(users: UsersAccountDTO): void {
    this.users = users;
  }

  /**
   * Retrieves the current users
   */
  public getUsers(): UsersAccountDTO | null {
    return this.users ?? null;
  }

  /**
   * clear the current users
   */
  public clearUsers() {
    this.users = undefined;
  }

  /**
   * Sets the main user
   * @param user - Instance of UsersAccountDTO or RelatedProfileDTO
   */
  public setMainUser(user: UsersAccountDTO | RelatedProfileDTO): void {
    this.user = user;
  }

  /**
   * Retrieves the main user
   */
  public getMainUser(): UsersAccountDTO | RelatedProfileDTO | null {
    return this.user ?? null;
  }

  /**
   * Checks if a user has been selected
   */
  public isUserSelected(): boolean {
    return !!this.user?.['fullName'];
  }

  /**
   * Sets specialist data
   * @param event - FormGroup instance representing the specialist data
   */
  public setSpecialistData(event: FormGroup): void {
    this.specialistChosen = event;
  }

  /**
   * Retrieves the specialist data
   */
  public getSpecialistData(): FormGroup | null {
    return this.specialistChosen ?? null;
  }

  /**
   * Sets request selection data
   * @param event - FormGroup instance representing the request data
   */
  public setSelectionData(event: FormGroup): void {
    this.requestChosen = event;
  }

  /**
   * Retrieves request selection data
   */
  public getSelectionData(): FormGroup | null {
    return this.requestChosen ?? null;
  }

  /**
   * Sets date selection data
   * @param event - Array of Appointment instances
   */
  public setDateSelectionData(event: Appointment[]): void {
    this.dateSelectionChosen = event;
  }

  /**
   * Retrieves date selection data
   */
  public getDateSelectionData(): Appointment[] | null {
    return this.dateSelectionChosen ?? null;
  }

  /**
   * Sets data for radio alimentation
   * @param radioInfo - FormControl instance
   */
  public setRadioAlimentationData(radioInfo: FormGroup): void {
    this.radioAlimentationChosen = radioInfo;
  }

  /**
   * Retrieves radio alimentation data
   */
  public getRadioAlimentationData(): FormGroup | null {
    return this.radioAlimentationChosen ?? null;
  }

  /**
   * Set appointmnet type data for vet
   */
  public setAppointmentType(type: string | null) {
    this.appointmentType = type;
  }

  /**
   * Get documents uploaded
   */
  public getDocuments(): IDocumentCard[] | null {
    return this.documentsChosen ?? null;
  }

  /**
   * Set documents uploaded
   */
  public setDocuments(document: IDocumentCard) {
    this.documentsChosen?.push(document);
  }

  /**
   * Get travel form data
   */
  public getTravelFormData(): any {
    return this.travelFormChosen ?? null;
  }

  /**
   * Set travel form data
   */
  public setTravelFormData(data: any) {
    this.travelFormChosen = data;
  }

  /**
   * Get appointmnet type data for vet
   */
  public getAppointmentType(): string | null {
    return this.appointmentType ?? null;
  }

  /**
   * Clears all stored data
   */
  public clearData(): void {
    this.users = undefined;
    this.user = undefined;
    this.specialistChosen = undefined;
    this.requestChosen = undefined;
    this.dateSelectionChosen = undefined;
    this.radioAlimentationChosen = undefined;
    this.documentsChosen = [];
  }
}
